<template>
  <div id="creator_country_invite_success">
    <van-row>
      <van-col span="22" offset="1" class="creator_country_invite_success_title">
        <img :src="app_logo"/> {{ app_name }}
      </van-col>
      <van-col span="24" class="creator_country_invite_success_bg">
        <van-col span="18" offset="3">
          <van-col span="24" class="creator_country_invite_success_bg_text">Congratulations!</van-col>
          <van-col span="24" class="creator_country_invite_success_bg_text">You have successfully become a Meno agency!</van-col>
          <van-col span="24" class="creator_country_invite_success_bg_text">Go develop your business,making money in Meno is super easy!</van-col>
          <van-col span="24" class="creator_country_invite_success_bg_text_r">Meno Team</van-col>
        </van-col>
        <van-col span="23" class="creator_country_invite_success_bg_icon">
          <img src="../assets/img/creator/creator_country_invite_success_icon.png"/>
        </van-col>
         <van-col span="20" offset="2" class="creator_country_invite_success_text">
          WHAT MENO OFFERS IS BEYOND ALL APPS
        </van-col>
      </van-col>
      <van-col span="20" offset="2" class="creator_country_invite_success_type_list">
        <van-col span="10" offset="1" class="creator_country_invite_success_type creator_country_invite_success_type1">
          <van-col span="24" class="creator_country_invite_success_type_title">Gift Commission</van-col>
          <van-col span="24" class="creator_country_invite_success_type_text">Real-time settlement  </van-col>
        </van-col>
        <van-col span="10" offset="2" class="creator_country_invite_success_type creator_country_invite_success_type2">
          <van-col span="24" class="creator_country_invite_success_type_title">Up to 5000$</van-col>
          <van-col span="24" class="creator_country_invite_success_type_text">Weekly bonus for room owners</van-col>
        </van-col>
        <van-col span="10" offset="1" class="creator_country_invite_success_type creator_country_invite_success_type3">
          <van-col span="24" class="creator_country_invite_success_type_title">Up to 20$ /h</van-col>
          <van-col span="24" class="creator_country_invite_success_type_text">Bonus for hosts</van-col>
        </van-col>
        <van-col span="10" offset="2" class="creator_country_invite_success_type creator_country_invite_success_type4">
          <van-col span="24" class="creator_country_invite_success_type_title">3000 coin reward</van-col>
          <van-col span="24" class="creator_country_invite_success_type_text">income for every host (every day)</van-col>
        </van-col>
      </van-col>
        <van-col span="24" class="invite_guide_bottom">
        <van-col span="5" class="invite_guide_bottom_img">
          <img :src="app_logo"/>
        </van-col>
        <van-col span="11" class="invite_guide_bottom_name">
          <van-col span="24" class="invite_guide_bottom_name_text">{{ app_name }}</van-col>
          <van-col span="24" class="invite_guide_bottom_name_center">Video & Voice Room</van-col>
        </van-col>
         <van-col span="7" class="invite_guide_bottom_btn">
          <van-button block size="small" color="linear-gradient(to right, #A529FF,#FF6CF6)" round @click="openApp">Open App</van-button>
         </van-col>
      </van-col>
    </van-row>
  </div>
</template>

<script>
import '@/assets/css/style.css'
import axios from "axios";
import {Toast} from "vant";
import {judgeIosAndroid} from "../assets/js/models";

export default {
  data() {
    return {
       // 应用配置
      appConfig: {
        openAppTimeout: 2000,  // 超时设置
        appOpenDetectionDelay: 1500,
        returnToPageDelay: 300,
        // 自动打开应用
        autoOpenApp: false
      },
      config: {
        // 应用基本信息
        appName: '',
        packageName: '',
        // 应用协议配置
        scheme: '',
        ios_scheme: '',
        host: '',
        path: '',
        androidDownloadUrl: '', // 下载链接
      },
      app_name: '',
      app_logo: ''
    }
  },
  created() {
    this.getConfig()
    this.convert()
  },
  methods: {
     convert() {
      this.overlayShow = true
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=creator_country&act=get_invite_agency_success", {
        params : {
          invite_code: this.invitation_code
        }
      }).then(res =>{
        this.overlayShow = false
        if (res.data.status === 0) {
          Toast(res.data.error)
          return false
        }
        this.app_name = res.data.data.app_name
        this.app_logo = res.data.data.app_logo
      })
    },
    getConfig() {
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=user_h5&act=share_config").then(res =>{
        this.config = res.data.data
      })
    },
    openApp() {
      const isIos = judgeIosAndroid();
      let scheme = this.config.scheme
      if (isIos === true) {
        // ios
        scheme = this.config.ios_scheme
      }
      // 构建拉起App的URL
      const appUrl = scheme + `://${this.config.host}${this.config.path}`;
      // 尝试打开App
      window.location.href = appUrl;
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/creator_country_invite_success.vue